import React from 'react';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { Field } from '../../../headless/field';
import { Required } from './required';

interface LabelFileUploadProps {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

const LabelRoot = React.forwardRef<HTMLDivElement, LabelFileUploadProps>(
  (props, ref) => {
    const { children, asChild, className } = props;
    const { id, label, showLabel } = useFieldProps<PublicFileUploadProps>();

    if (!showLabel) {
      return null;
    }

    return (
      <Field.Label ref={ref} asChild={asChild} className={className}>
        <label htmlFor={id}>
          {label}
          {children}
        </label>
      </Field.Label>
    );
  },
);

LabelRoot.displayName = 'FileUpload.Label';

export interface LabelFileUploadComponent
  extends React.ForwardRefExoticComponent<
    LabelFileUploadProps & React.RefAttributes<HTMLDivElement>
  > {
  Required: typeof Required;
}

export const Label = LabelRoot as LabelFileUploadComponent;
Label.Required = Required;
